export class BreadCrumbElement {
  public name = "";
  public link = "";
}
